import React, { useState, useEffect, useRef } from "react";
import "./ChatResponse.scss";
import AnswerDisplay from "./AnswerDisplay";
import Alert from "@mui/material/Alert";
import { Avatar } from "@mui/material";
import DisplayUserInput from "./DisplayUserInput";
import botImg from "../../app/assets/videos/Loading-gif.gif";
import PushPinIcon from "@mui/icons-material/PushPin";
import axios from "axios";
import { useHistory } from "react-router-dom";
import PinningPopup from "../history/PinningPopup";
import SocketResponse from "../Reusable/SocketResponse";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link2Icon, PinIcon } from "lucide-react";

const loadingMessages = [
  { text: "Understanding the questions...", delay: 2000 },
  { text: "Generating SQL...", delay: 2000 },
  { text: "Synthesizing the insights...", delay: 2000 },
  { text: "Preparing reports...", delay: 2000 },
];

const ChatResponse = ({
  message,
  query,
  setIsLoading,
  isLoading,
  index,
  printPDF,
  loadingIndex,
  setResponceData,
  isHistory,
  page,
  responceData,
  handleSendClickNew,
  displayedLogs
}) => {
  const [open, setOpen] = useState(false);
  const [loadingStep, setLoadingStep] = useState(0);
  const chatEndRef = useRef(null);
  const [isPinned, setIsPinned] = useState(
    (message && message?.pin_response) || false
  );
  const [pinError, setPinError] = useState(false);
  const [pinSuccess, setPinSuccess] = useState(false);
  const [pinLoading, setPinLoading] = useState(false);
  const history = useHistory();
  const [expandedIndex, setExpandedIndex] = useState(0);

  const handlePin = async (messageId, child_question_id) => {
    let baseUrl = "";
    let data = null;
    try {
      if (!isPinned) {
        baseUrl = `${process.env.REACT_APP_BASE_URL}/aadi/pin`;
        data = {
          messageID: messageId,
          email: `${localStorage.getItem("userinfo")}`,
          child_question_id: child_question_id,
        };
      } else {
        baseUrl = `${process.env.REACT_APP_BASE_URL}/aadi/remove/pin`;
        data = {
          messageID: messageId,
          email: `${localStorage.getItem("userinfo")}`,
        };
      }
      setPinLoading(true);

      const response = await axios.post(baseUrl, data);

      if (response.status === 200) {
        setPinLoading(false);
        setPinSuccess(true);
        setTimeout(() => {
          setPinSuccess(false);
        }, 2000);
        setIsPinned((prevState) => !prevState);
      } else {
        console.error(
          "Error delete history data:",
          response.status,
          response.statusText
        );
        setPinLoading(false);
        setPinError(true);
        setTimeout(() => {
          setPinError(false);
        }, 2000);
      }
    } catch (error) {
      setPinLoading(false);
      console.error("Error delete history chat:", error);
      setPinError(true);
      setTimeout(() => {
        setPinError(false);
      }, 2000);
    }
  };

  useEffect(() => {
    if (isLoading && loadingStep < loadingMessages.length) {
      const timer = setTimeout(() => {
        setLoadingStep((prevState) => prevState + 1);
      }, loadingMessages[loadingStep].delay);

      return () => clearTimeout(timer);
    }
  }, [isLoading, loadingStep]);

  useEffect(() => {
    if (!isLoading && page === "Home") {
      setResponceData((prevState) => {
        // Create a new array with updated loading status
        return prevState.map((item) => {
          // If the item has loading as true, set it to false
          if (item.loading) {
            return { ...item, loading: false }; // return a new object with updated loading property
          }
          return item; // return the item unchanged if loading is not true
        });
      });
    }
  }, [isLoading]);

  console.log("message", message);
  const iscached = message && message?.content &&  message?.content.length > 0 && message?.content[0]?.from_cache;

  const headerData = Array.isArray(message?.content)
  ? message.content.map(item => item?.header).filter(Boolean)
  : [];

console.log("headerData", headerData);

  return (
    <>
      {page && page === "Pin" && (
        <div id={`message-${index}`} className={`query-container`}>
          <DisplayUserInput message={message} />

          <div className="answer-card">
            <div className={`answer-cont`}>
              <div className="avatar-container">
                <Avatar sx={{ background: "#1d64ac" }}>A</Avatar>
                <div className="pin-cont">
                  <PushPinIcon
                    className={`pin-icon ${isPinned ? "pinned" : ""}`}
                    onClick={() => handlePin(message?.message_id)}
                  />
                </div>
              </div>

              <div className="main-card">
                {message?.content.map((item, index) => (
                  <AnswerDisplay
                    key={item.child_question_id}
                    item={item}
                    setIsLoading={setIsLoading}
                    isLoading={isLoading}
                    responseId={message?.message_id}
                    setOpen={setOpen}
                    open={open}
                    index={item.child_question_id}
                    responseNumber={message?.content.length}
                    isPinned={isPinned}
                    pinError={pinError}
                    handlePin={handlePin}
                    pinLoading={pinLoading}
                    message={message}
                    setResponceData={setResponceData}
                    responceData={responceData}
                    handleSendClickNew={handleSendClickNew}
                    displayedLogs={displayedLogs}
                    query={query}
                  />
                ))}
              </div>
              <div className="pin-message">
                {pinError && (
                  <Alert severity="error">
                    Something went wrong. please try again.
                  </Alert>
                )}
                {pinSuccess && (
                  <Alert severity="success">
                    Response unpinned successfully.
                  </Alert>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {(page === "Home" || page === "Dashboard") &&
        (isHistory ? (
          <div id={`message-${index}`} className={`query-container`}>
            <DisplayUserInput message={message?.response} />

            <div className="answer-card">
              <div className={`answer-cont`}>
                <div className="avatar-container">
                  <Avatar sx={{ background: "#1d64ac" }}>A</Avatar>
                  <div className="pin-cont">
                    <PushPinIcon
                      className={`pin-icon ${isPinned ? "pinned" : ""}`}
                      onClick={() => handlePin(message?.response?.message_id)}
                    />
                  </div>
                </div>
                {message?.response?.summary_of_summaries &&
                  message?.response?.summary_of_summaries.toLowerCase() !==
                    "na" &&
                  message?.response?.summary_of_summaries.toLowerCase() !==
                    "n/a" && (
                    <>
                      <div className="summary-section">
                        {/* <h3>Overall Summary</h3> */}
                        <p>{message?.response?.summary_of_summaries}</p>
                      </div>
                      <span style={{borderRadius:"6px"}} className="supporting-txt p-2 mb-3 block bg-gradient-to-r from-[#1d64ac]/20 to-[#1d64ac]/70 font-bold">Supporting Facts</span>
                      </>
                  )}
                <div className="main-card">
                  {message?.response?.content.map((item, index) => (
                    <AnswerDisplay
                      key={item.child_question_id}
                      item={item}
                      setIsLoading={setIsLoading}
                      isLoading={isLoading}
                      responseId={message?.response.message_id}
                      setOpen={setOpen}
                      open={open}
                      index={item.child_question_id}
                      responseNumber={message?.response?.content.length}
                      isPinned={isPinned}
                      pinError={pinError}
                      handlePin={handlePin}
                      pinLoading={pinLoading}
                      message={message}
                      setResponceData={setResponceData}
                      responceData={responceData}
                      handleSendClickNew={handleSendClickNew}
                      displayedLogs={displayedLogs}
                      query={query}
                    />
                  ))}
                </div>
                <div className="pin-message">
                  {pinError && (
                    <Alert severity="error">
                      Something went wrong. please try again.
                    </Alert>
                  )}
                  {pinSuccess && (
                    <Alert severity="success">
                      Response pinned successfully.
                    </Alert>
                  )}
                </div>
              </div>
            </div>

            {!isLoading && !message.user && message.error && (
              <div className="answer-card">
                <div className={`answer-cont`}>
                  <div className="avatar-container">
                    <Avatar sx={{ background: "#1d64ac" }}>A</Avatar>
                  </div>
                  <p className="error-message">
                    Something went wrong. Please try again.
                  </p>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div
            id={`message-${index}`}
            className={`query-container ${
              message.loading ? "full-height" : ""
            }`}
          >
            {message.user && (
              <>
                { !iscached && <DisplayUserInput message={message} />}
                <div ref={chatEndRef} />
                {message.loading && (
                  <div className="loading-cont1">
                    <p className="loading-text">
                      <SocketResponse />
                    </p>
                  </div>
                )}
              </>
            )}

            {!message.loading &&
              message?.content &&
              !message.user &&
              !message.error && (
                <>
                  <div
                    className={
                      message && message?.content && message?.content.length > 1
                        ? "border p-6 rounded bg-gray-100"
                        : ""
                    }
                  >
                    <span>
                      {message?.summary_of_summaries &&
                        message?.summary_of_summaries.toLowerCase() !== "na" &&
                        message?.summary_of_summaries.toLowerCase() !==
                          "n/a" && (
                          <>
                            <div className="summary-section">
                              {/* <h3>Overall Summary</h3> */}
                              <p>{message.summary_of_summaries}</p>
                            </div>
                            <span style={{borderRadius:"6px"}} className="supporting-txt p-2 mb-3 block bg-gradient-to-r from-[#1d64ac]/20 to-[#1d64ac]/70 font-bold">Supporting Facts</span>
                          </>
                        )}
                  <div
  className={
    message?.content?.length > 1
      ? "grid grid-col-1 gap-4"
      : ""
  }
>
  {/* ✅ MULTIPLE ITEMS → Accordion */}
  {Array.isArray(message?.content) && message.content.length > 1 &&
    message.content.map((item, idx) => (
      <Accordion
        key={item?.child_question_id || idx}
        expanded={expandedIndex === idx}
        onChange={() => setExpandedIndex(idx)}
        sx={{
          mb: 1,
          borderRadius: 2,
          backgroundColor: "linear-gradient(to right, #f0f4ff, #d9e2ff)",
          boxShadow: "none",
          border: "1px solid #e0e0e0",
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <span className="font-semibold text-[#1d64ac] flex gap-2 items-center">
            <Link2Icon />
            Question {idx + 1} {`: ${item.header || ""}`}
          </span>
        </AccordionSummary>

        <AccordionDetails>
          <AnswerDisplay
            item={item}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            responseId={message.message_id}
            setOpen={setOpen}
            open={open}
            index={item.child_question_id}
            printPDF={printPDF}
            responseNumber={message?.content?.length ?? 0}
            isPinned={isPinned}
            pinError={pinError}
            handlePin={handlePin}
            pinLoading={pinLoading}
            message={message}
            setResponceData={setResponceData}
            responceData={responceData}
            handleSendClickNew={handleSendClickNew}
            displayedLogs={displayedLogs}
            query={query}
          />
        </AccordionDetails>
      </Accordion>
    ))}

  {/* ✅ SINGLE ITEM → NORMAL VIEW (no accordion) */}
  {Array.isArray(message?.content) && message.content.length === 1 && (
    <>
      {message.content[0]?.header && (
        <div className="content-header mb-2 font-semibold text-[#1d64ac]">
          {message.content[0].header}
        </div>
      )}

      <AnswerDisplay
        item={message.content[0]}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        responseId={message.message_id}
        setOpen={setOpen}
        open={open}
        index={message.content[0]?.child_question_id}
        printPDF={printPDF}
        responseNumber={1}
        isPinned={isPinned}
        pinError={pinError}
        handlePin={handlePin}
        pinLoading={pinLoading}
        message={message}
        setResponceData={setResponceData}
        responceData={responceData}
        handleSendClickNew={handleSendClickNew}
        displayedLogs={displayedLogs}
        query={query}
      />
    </>
  )}
</div>

                    </span>
                    <span className="pin-message">
                      {pinError && (
                        <Alert severity="error">
                          Something went wrong. please try again.
                        </Alert>
                      )}
                      {pinSuccess && (
                        <Alert severity="success">
                          {isPinned
                            ? "Response pinned successfully."
                            : "Response unpinned successfully."}
                        </Alert>
                      )}
                    </span>
                  </div>
                </>
              )}
            {!isLoading && !message.user && message.error && (
              <div className="answer-card">
                <div className={`answer-cont`}>
                  <div className="avatar-container">
                    <Avatar sx={{ background: "#1d64ac" }}>A</Avatar>
                  </div>
                  <p className="error-message" style={{ marginTop: "16px" }}>
                    Something went wrong. Please try again.
                  </p>
                </div>
              </div>
            )}
            {open && (
              <PinningPopup
                open={open}
                setOpen={setOpen}
                messageID={message.message_id}
                pinLoading={pinLoading}
                handlePin={handlePin}
                isPinned={isPinned}
                item={message}
              />
            )}
          </div>
        ))}
    </>
  );
};

export default ChatResponse;
